//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import angular, { IRootScopeService } from 'angular';

interface IUniversalImageActionsRightsOptionsService {
  getShouldShowRightsOptions: () => boolean;
  setShouldShowRightsOptions: (value: boolean) => void;
}

// This class is to support communication between universal-image-actions-workflow
// and universal-image-actions-rights-requests to handle showing the UIARightsOptions
// within the Galleries workflow and properly handle the "previous" button
export class UniversalImageActionsRightsOptionsService
  implements IUniversalImageActionsRightsOptionsService
{
  private shouldShowRightsOptions = true;

  constructor(private readonly $rootScope: IRootScopeService) {}

  public getShouldShowRightsOptions(): boolean {
    return this.shouldShowRightsOptions;
  }

  public setShouldShowRightsOptions(value: boolean): void {
    this.shouldShowRightsOptions = value;
    this.$rootScope.$broadcast('uia:rights-options:state-changed', value);
  }
}

angular
  .module('uia')
  .service('UniversalImageActionsRightsOptionsService', [
    '$rootScope',
    UniversalImageActionsRightsOptionsService,
  ]);
